<template>
  <div class="header">
    <div class="headerBox">知识库管理系统</div>
    <!-- header内容填充。设置布局 -->
    <!-- 退出按钮 -->
    <div class="header-right">
      <el-button class="cancelButton" @click="quit">退出</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      centerDialogVisible: false,
    };
  },
  mounted() {
    // window.addEventListener('popstate', this.handlePopState);
  },
  computed: {
    ...mapGetters(["isCollapse"]),
  },
  // beforeDestroy() {
  //   window.removeEventListener('popstate', this.handlePopState);
  // },
  methods: {
    // handlePopState() {
    //   this.centerDialogVisible= true;
    // },
    // goBack() {
    //   window.history.back();
    // },
    ...mapActions(["CHANGE_COLLAPSE"]),
    quit() {
      // window.sessionStorage.removeItem("token");
      this.$router.push({
        path: "/login", // 修正路径为绝对路径
      });
      // this.centerDialogVisible = false; // 关闭对话框
      this.$message({
        type: "success",
        message: "成功退出登录!",
      });
    },
    jump() {
      this.$router.push({
        path: "/project",
      });
      this.centerDialogVisible = false; // 关闭对话框
      this.$message({
        type: "success",
        message: "知识库管理跳转成功!",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.backContainer {
  display: flex;
  /* 使用 flex 布局 */
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中（可选，根据需要） */
  height: 100%;
  /* 确保容器有高度 */
}
.backBtn {
  cursor: pointer;
  // padding-top: 1px;
  margin-right: 24px;
  width: 80px;
  height: 36px;
}

.menuIcon {
  cursor: pointer;
  // font-size: 25px;
  // color: white;
  width: 46px;
  height: 36px;
  margin-left: 24px;
}

span {
  font-size: 1.5vw;
}

// .button{
//   margin-left: 20px;
//   padding: 0 !important;

// }
.btn-menu {
  // margin-right: 6%;
  // margin-top: 24px;
  // float: right;
}

.header-top {
  margin: 8px 0;
  width: 100%;
  // background-color: #ffffff;
  // padding: 0 18px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* 两端对齐 */
}

.header {
  width: 100%;
  display: flex;
  flex-direction: column;
  // height: 100px;
  // background-image: url("@/assets/base/header.png");
}

.headerBox {
  margin: 0;
  color: #fff;
  /* 调整字体颜色，与背景形成对比 */
  font-size: 24px;
  /* 调整文字大小 */
  display: flex;
  /* 使用 Flexbox 居中内容 */
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  width: 100%;
  /* 占满整个宽度 */
  height: 70px;
  /* 固定高度 */
  background-image: url("@/assets/base/header.png");
  background-repeat: no-repeat;
  /* 防止图片重复 */
  background-position: center;
  /* 图片居中 */
  background-size: cover;
  /* 图片按容器宽高比例裁剪适应 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  /* 添加阴影效果 */
}
.header-right{
  position: absolute;
  right: 27px;
  top: 20px;
}
.btnBox {
  background-color: #fff;
  width: 100%;
  height: 36px;
  // background-color: #fff;
}
.headerDialog /deep/ .el-dialog__body {
  width: 440px;
  height: 100px;
}

/* 自定义对话框样式 */
.custom-dialog {
  .el-dialog__wrapper {
    z-index: 10000;
    /* 确保弹窗在最上层 */
    top: 50%;
    /* 上边距为页面高度的一半 */
    left: 50%;
    /* 左边距为页面宽度的一半 */
    transform: translate(-50%, -50%);
    /* 使用transform属性将弹窗向左上角偏移自身宽高的一半，实现居中对齐 */
  }
}

.el-submenu__icon-arrow {
  color: #fff;
}
</style>
